/* eslint-disable no-nested-ternary */
import React from 'react';
import { connect } from 'react-redux';
import _delay from 'lodash/delay';
import classnames from 'classnames';
import PropTypes from 'prop-types';
// Core components
import AppLoader from 'components/core/AppLoader';
// Custom
import { invoke } from 'utils/Tools';

const DISPLAY_LOADER_DELAY = 500;

class LoadingDisplayer extends React.Component {
  constructor(props) {
    super(props);

    this.doDisplayLoading = this.doDisplayLoading.bind(this);

    // Mount flag
    this._isMounted = false;

    const { loading } = this.props;
    this.state = {
      loading,
      displayLoading: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;

    // Check if loading is in progress
    const { loading } = this.props;
    if (loading) {
      _delay(this.doDisplayLoading, DISPLAY_LOADER_DELAY);
    }
  }

  componentDidUpdate(prevProps) {
    const { loading, forceHide, onForceHide } = this.props;
    const { loading: prevLoading, forceHide: prevForceHide } = prevProps;

    // Remove loading if necessary
    if (
      (prevLoading && !loading)
      || (!prevForceHide && forceHide)
    ) {
      invoke(() => {
        this.setState({
          loading: false,
          displayLoading: false,
        });
      });

      // Inform parent on force hide
      if (!prevForceHide && forceHide && onForceHide) {
        onForceHide();
      }
    }
    // Set loading flag
    if (!prevLoading && loading) {
      invoke(() => {
        this.setState({
          loading: true,
        }, () => {
          _delay(this.doDisplayLoading, DISPLAY_LOADER_DELAY);
        });
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  // Private
  doDisplayLoading() {
    if (this._isMounted) {
      const { loading } = this.state;
      if (loading) {
        // Display loading after a delay to avoid displaying it on short loadings
        this.setState({ displayLoading: true });
      }
    }
  }

  render() {
    const { loading, displayLoading } = this.state;
    const {
      mountChildrenWhileLoading,
      forceHideChildren,
      withShrink,
      children,
    } = this.props;

    return (
      <div className={
          classnames('h-100 c-blockui', {
            'c-blockui-loading': loading,
          })
        }
      >
        { (!loading || mountChildrenWhileLoading) ? (
          forceHideChildren
            ? <div style={{ display: 'none' }}>{children}</div>
            : children)
          : null }
        { loading && (
        <div className="c-blockui-container">
          <div className="c-blockui-veil" />
          <div className="c-blockui-loader">
            { displayLoading && (
            <AppLoader disableShrink={!withShrink} />
            )}
          </div>
        </div>
        )}
      </div>
    );
  }
}

LoadingDisplayer.propTypes = {
  loading: PropTypes.bool.isRequired,
  forceHideChildren: PropTypes.bool,
  mountChildrenWhileLoading: PropTypes.bool,
  withShrink: PropTypes.bool,
  children: PropTypes.node.isRequired,
  forceHide: PropTypes.bool.isRequired,
  onForceHide: PropTypes.func,
};

LoadingDisplayer.defaultProps = {
  mountChildrenWhileLoading: false,
  withShrink: false,
  onForceHide: null,
  forceHideChildren: false,
};

const mapStateToProps = (state) => ({
  forceHide: state.loading.forceHide,
});

module.exports = connect(
  mapStateToProps,
)(LoadingDisplayer);



// WEBPACK FOOTER //
// ./components/misc/LoadingDisplayer.js